export function fetch(id) { return { type: 'PERIODS/FETCH', id } } // this is the id of the room
export function fetch_one(id) { return { type: 'PERIOD/FETCH', id } }
export function archive(id, IdRoom) { return { type: 'PERIOD/ARCHIVE', id, IdRoom } }
export function clean() { return { type: 'PERIOD/CLEAR' } }
export function toggle(id, IsActive) { return { type: 'PERIOD/TOGGLE', id, IsActive } }